<template>
    <div class="style-info-tab">
        <!-- 1. 款式信息 -->
        <div class="section-block">
            <div class="style-info-wrapper">
                <div class="style-left-col">
                    <div class="stick-title">
                        <span class="stick"></span>
                        款式图：
                    </div>
                    <div class="style-gallery" v-viewer>
                        <div class="gallery-image" v-for="(img, index) in (detail.image_list || [])" :key="index">
                            <img :src="img.raw" alt="款式图" />
                        </div>
                    </div>
                </div>
                <div class="style-right-col">
                    <div class="detail-list">
                        <div class="stick-title">
                            <span class="stick"></span>
                            款式信息：
                        </div>
                        <div class="detail-item">
                            <span class="label">款号：</span>
                            <span class="value">{{ detail.style_no }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">款式分类：</span>
                            <span class="value">{{ detail.product_category_name }}</span>
                        </div>
                        <div class="detail-item" v-if="detail.status >= 3">
                            <span class="label">二次下单价格：</span>
                            <span class="value">{{ detail.refactory_price|price_format }}元</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">创建时间：</span>
                            <span class="value">{{ detail.create_time }}</span>
                        </div>
                    </div>

                    <div class="detail-desc">
                        <div class="stick-title">
                            <span class="stick"></span>
                            款式说明：
                        </div>
                        <div class="desc-content">
                            {{ detail.description }}
                        </div>
                    </div>

                    <div class="style-files">
                        <div class="stick-title">
                            <span class="stick"></span>
                            版型文件：
                        </div>
                        <div class="file-item" v-for="(file, index) in (detail.pattern || [])" :key="index">
                            <img class="file-icon" :src="getFileType(file.name)" alt="文件"></img>
                            <span v-if="detail.pattern_type === 1">{{ file.name }}</span>
                            <a v-else class="link" target="_blank" :href="file.path">{{ file.name }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 2. 印花结果 -->
        <div class="section-block">
            <div class="stick-title">
                <span class="stick"></span>
                印花信息：
            </div>
            <table class="data-table">
                <thead>
                    <tr>
                        <th>印花图案</th>
                        <th>印花文件</th>
                        <th>印花宽高 (cm)</th>
                        <th>工艺</th>
                        <th>平台工艺</th>
                        <th>部位</th>
                        <th>备注说明</th>
                        <th>价格(元)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in (detail.yinhua || [])" :key="index">
                        <td>
                            <div class="file-img">
                                <img :src="item.raw" alt="图案" />
                            </div>
                        </td>
                        <td>
                            <div class="file-link">
                                <a class="link" :href="item.raw" target="_blank">{{ item.raw_name }}</a>
                            </div>
                        </td>
                        <td>{{ item.x }} * {{ item.y }}</td>
                        <td>{{ item.tech_name }}</td>
                        <td>{{ item.own_tech_name }}</td>
                        <td>{{ item.buwei }}</td>
                        <td>{{ item.content }}</td>
                        <td>{{ item.price }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 3. 绣花信息 -->
        <div class="section-block">
            <div class="section-title">
                <span class="stick"></span>
                绣花信息：
            </div>
            <table class="data-table">
                <thead>
                    <tr>
                        <th>绣花图案</th>
                        <th>绣花文件</th>
                        <th>绣花宽高 (cm)</th>
                        <th>部位</th>
                        <th>平台工艺</th>
                        <th>针法</th>
                        <th>色数</th>
                        <th>线色</th>
                        <th>备注说明</th>
                        <th>价格(元)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in (detail.xiuhua || [])" :key="index">
                        <td>
                            <div v-if="item.raw" class="file-img">
                                <img :src="item.raw" alt="图案" v-viewer />
                            </div>
                        </td>
                        <td>
                            <div class="file-link">
                                <a class="link" :href="item.raw" target="_blank">{{ item.raw_name }}</a>
                            </div>
                        </td>
                        <td>{{ item.x }} * {{ item.y }}</td>
                        <td>{{ item.buwei }}</td>
                        <td>{{ item.own_tech_name }}</td>
                        <td>{{ item.stitchType }}</td>
                        <td>{{ item.needle }}</td>
                        <td>{{ item.line_color }}</td>
                        <td>{{ item.content }}</td>
                        <td>{{ item.price }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 4. 特殊工艺 -->
        <div class="section-block">
            <div class="stick-title">
                <span class="stick"></span>
                特殊工艺：
            </div>
            <table class="data-table">
                <thead>
                    <tr>
                        <th>工艺</th>
                        <th>类型</th>
                        <th>名称</th>
                        <th>备注说明</th>
                        <th>价格(元)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in (detail.special_tech_info || [])" :key="index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.obj_name }}</td>
                        <td>{{ item.remark }}</td>
                        <td>{{ item.price }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 5. 其他信息 -->
        <div class="section-block other-info-block">
            <div class="stick-title">
                <span class="stick"></span>
                其他信息：
            </div>
            <div class="other-info-grid">
                <div class="info-row">
                    <div class="info-col">
                        <div class="info-item">
                            <div class="info-label">面料附件：</div>
                            <div class="info-content file-group" style="margin-left: 14px;">
                                <div class="file-link" v-for="(item, index) in (detail.material_file || [])" :key="index">
                                    <img class="file-icon" :src="getFileType(item.name)" />
                                    <a class="link" :href="item.path" target="_blank">{{ item.name }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-col">
                        <div class="info-item">
                            <div class="info-label">辅料附件：</div>
                            <div class="info-content file-group" style="margin-left: 14px;">
                                <div class="file-link" v-for="(item, index) in (detail.accessory_file || [])" :key="index">
                                    <img class="file-icon" :src="getFileType(item.name)" />
                                    <a class="link" :href="item.path" target="_blank">{{ item.name }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-col">
                        <div class="info-label">包装方式：</div>
                        <div class="info-content file-group" style="margin-top: 16px;">
                            <div class="file-link" v-for="(item, index) in (detail.package_label && detail.package_label.package_files || [])" :key="index">
                                <img class="file-img" :src="item.url" alt="包装" v-viewer />
                                <a class="link" :href="item.url" target="_blank">{{ item.name }}</a>
                            </div>
                        </div>
                        <div class="info-remark" style="margin-top: 16px;">
                            <div class="remark-label">备注说明：</div>
                            <div class="remark-content">{{ detail.package_label && detail.package_label.package_description || '无' }}</div>
                        </div>
                    </div>
                    <div class="info-col">
                        <div class="info-label">吊牌信息：</div>
                        <div class="info-content file-group" style="margin-top: 16px;">
                            <div class="file-link" v-for="(item, index) in (detail.package_label && detail.package_label.label_files || [])" :key="index">
                                <img class="file-img" :src="item.url" alt="吊牌" v-viewer />
                                <a class="link" :href="item.url" target="_blank">{{ item.name }}</a>
                            </div>
                        </div>
                        <div class="info-remark" style="margin-top: 16px;">
                            <div class="remark-label">备注说明：</div>
                            <div class="remark-content">{{ detail.package_label && detail.package_label.label_description || '无' }}</div>
                        </div>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-col">
                        <div class="info-label">其他附件：</div>
                        <div class="file-group" style="margin-top: 16px;">
                            <div class="file-link" v-for="(item, index) in (detail.other_file || [])" :key="index">
                                <img class="file-icon" :src="getFileType(item.name)" alt="附件" />
                                <a class="link" :href="item.path" target="_blank">{{ item.name }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StyleInfoTab',
    props: {
        detail: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            images: [],
        };
    },
    created() {
        // 参数：(目录路径, 是否递归子目录, 文件名正则)
        const context = require.context('@/assets/images/design/file', false, /\.(png|jpe?g|gif|svg|webp)$/i)

        this.images = context.keys().map(key => ({
            name: key.replace(/^\.\/(.*)\.\w+$/, '$1'), // 提取文件名（不含扩展名）
            url: context(key) // 获取处理后的资源路径（带 hash）
        }))

        console.log('detail', this.detail);
    },
    methods: {
        getFileType(fileName) {
            let type = (fileName.split('.')[1] || '').toLowerCase();
            if (['xlsx', 'xls'].includes(type)) {
                type = 'excel';
            }
            if (['docx', 'doc'].includes(type)) {
                type = 'word';
            }
            if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(type)) {
                type = 'jpg';
            }
            const fileType = this.images.find(item => item.name === type);
            if(fileType) {
                return fileType.url;
            }
            return this.images.find(item => item.name === 'default').url;
        }
    }
};
</script>

<style lang="scss" scoped>
.link {
    color: #0D99FF;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}
.style-info-tab {
    font-size: 14px;
    line-height: 21px;

    .stick {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: #FF5967;
        border-radius: 4px;
        margin-right: 6px;
    }

    .stick-title {
        font-weight: 500;
        color: #000000;
        display: flex;
        align-items: center;
    }

    .section-block {
        margin-bottom: 20px;

        .section-title {
            color: #000000;
            font-weight: 500;
        }
    }

    /* 1. 款式信息 */
    .style-info-wrapper {
        display: flex;
        border-collapse: collapse;

        .style-left-col {
            flex: 1;
            min-width: 0;
            border: 1px solid #e3e3e3;
            padding: 18px 20px 22px 20px;


            .style-gallery {
                margin-top: 14px;
                display: flex;
                flex-wrap: wrap;
                gap: 8px;

                .gallery-image {
                    width: 128px;
                    height: 128px;
                    aspect-ratio: 1/1;
                    border: 1px solid #e3e3e3;
                    border-radius: 4px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        cursor: pointer;
                    }
                }
            }
        }

        .style-right-col {
            flex: 1;
            min-width: 0;
            border: 1px solid #e3e3e3;
            border-left: none;
            display: flex;
            flex-direction: column;

            .detail-list {
                padding: 18px 20px 20px 22px;
                display: flex;
                flex-direction: column;
                gap: 12px;

                .detail-item {
                    &:first-child {
                        margin-top: 14px;
                    }

                    display: flex;
                    align-items: start;
                    justify-content: space-between;

                    .label {
                        text-align: left;
                        color: #666666;
                    }

                    .value {
                        text-align: right;
                        color: #333333;
                    }
                }
            }

            .detail-desc {
                flex: 1;
                padding: 18px 20px 20px 22px;
                border-top: 1px solid #e3e3e3;

                .desc-content {
                    margin-top: 10px;
                    color: #333333;
                }
            }

            .style-files {
                padding: 26px 20px 20px 22px;
                display: flex;
                align-items: center;
                gap: 8px;
                border-top: 1px solid #e3e3e3;

                .file-item {
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    .file-icon {
                        width: 32px;
                        height: 32px;
                    }
                }
            }
        }
    }

    /* 表格通用 */
    .data-table {
        margin-top: 12px;
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #e3e3e3;

        th,
        td {
            border-top: 1px solid #e3e3e3;
            border-bottom: 1px solid #e3e3e3;
            text-align: center;
            vertical-align: middle;
        }

        th {
            background: #F8F9FB;
            color: #666666;
            padding: 8px 8px;
        }

        td {
            color: #333333;
            padding: 12px 8px;

            .file-img {
                display: inline-block;
                width: 64px;
                height: 64px;
                object-fit: cover;
                border: 1px solid #e3e3e3;
                border-radius: 4px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            // .file-link {
            //     color: #0D99FF;
            //     cursor: pointer;
            // }
        }

    }

    /* 其他信息 */
    .other-info-block {
        .other-info-grid {
            margin-top: 12px;
            border-collapse: collapse;

            .info-row {
                display: flex;
                border: 1px solid #e3e3e3;
                border-bottom: none;

                &:last-child {
                    border-bottom: 1px solid #e3e3e3;
                }

                .info-col {
                    flex: 1;
                    padding: 24px 20px;

                    &:last-child {
                        border-left: 1px solid #e3e3e3;
                    }
                }

                .info-item {
                    display: flex;
                    align-items: start;
                }

                .info-label {
                    font-weight: 500;
                    color: #000000;
                    flex-shrink: 0;
                }

                .info-content {
                    flex: 1;

                }
                .file-group {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 18px 36px;

                    .file-link {
                        display: flex;
                        align-items: center;
                        // color: #1890ff;
                        // cursor: pointer;

                        // &:hover {
                        //     text-decoration: underline;
                        // }

                        .file-icon {
                            width: 32px;
                            height: 32px;
                            object-fit: cover;
                            margin-right: 8px;
                        }

                        .file-img {
                            width: 64px;
                            height: 64px;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #E3E3E3;
                            object-fit: cover;
                            margin-right: 20px;
                        }
                    }
                }

                .info-remark {
                    display: flex;
                    align-items: start;
                    .remark-label {
                        flex-shrink: 0;
                        color: #666666;
                    }

                    .remark-content {
                        text-align: left;
                        color: #333333;
                    }
                }
            }
        }
    }
}
</style>